import { useState, useEffect, Fragment } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import { Card, CardBody, CardHeader, Button, Modal } from 'react-bootstrap';

export default function ListarAtencionesJuridicas(){
    const navigate = useNavigate();
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [expandedMap, setExpandedMap] = useState({});
    const { idCabezaFamilia } = useParams();
    const [showActualizarArchivo, setShowActualizarArchivo] = useState(false);
    const [archivoActualizar, setArchivoActualizar] = useState(null);
    const [iddetallederivacionActualizar, setIddetallederivacionActualizar] = useState(null);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
            nombre: '',
            cab_idcabezafamilia: '',
            cab_direccion: '',
            telefono: '',
            cab_celular: '',
            cab_correoelectronico: '',
            cab_nodeclaracion: ''
          });
    const [atenciones, setAtenciones] = useState([]);
    
    const DescargarArchivo = async (filename) => {
        if (!filename) return;
        setCargando(true);
                
        try {
            const response = await apiService.getFile('/reparacion/descargararchivojuridico', { nombreArchivo: filename }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            setSwalProps({ show: true, title: 'Descargar archivo', text: `Hubo un error al descargar el archivo ${filename}: ${err}` });
        } finally {
            setCargando(false);
        }
    };
    async function CargarListaAtenciones(idCabezaFamilia) {
        let url = '/reparacion/listaratencionesjuridicas';
        let obj = {idCabezaFamilia: idCabezaFamilia}
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setAtenciones(result.atenciones);
            setCabezaFamiliaDatos(result.cabezafamilia);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await CargarListaAtenciones(idCabezaFamilia);
        };
        fetchData();
    }, [idCabezaFamilia, token]);

    function formatFecha(fecha){
        if(!fecha) return '';
        try{
            const d = new Date(fecha);
            const y = d.getFullYear();
            const m = String(d.getMonth()+1).padStart(2,'0');
            const day = String(d.getDate()).padStart(2,'0');
            return `${y}-${m}-${day}`;
        }catch(e){
            return fecha;
        }
    }
    function ActualizarArchivo(idAtencionJuridico) {
        setIddetallederivacionActualizar(idAtencionJuridico);
        handleShow();
    }
    async function handleActualizarArchivo() {
        if (!archivoActualizar) {
            setSwalProps({ show: true, title: 'Actualizar archivo', text: 'Por favor seleccione un archivo PDF.' });
            return;
        }
        const maxSize = 12 * 1024 * 1024; // 12 MB
        if (archivoActualizar.size > maxSize) {
            setSwalProps({ show: true, title: 'Actualizar archivo', text: 'El archivo seleccionado excede el tamaño máximo de 12 MB.' });
            return;
        }
        // validate filename: only letters and numbers (no special chars, no spaces)
        const nameOnly = archivoActualizar.name.replace(/\.[^/.]+$/, ''); // strip extension
        const validName = /^[A-Za-z0-9]+$/.test(nameOnly);
        if (!validName) {
            setSwalProps({ show: true, title: 'Actualizar archivo', text: 'El nombre del archivo solo puede contener letras y números, sin espacios ni caracteres especiales.' });
            return;
        }
        try {
            const url = '/reparacion/actualizararchivojuridico';
            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(archivoActualizar);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
            const formData = new FormData();
            formData.append('base64', base64);
            formData.append('filename', archivoActualizar.name);
            formData.append('id', iddetallederivacionActualizar);
            const response = await apiService.post(url, formData, token);
            if (response.status === 200) {
                setSwalProps({ show: true, title: 'Actualizar archivo', text: 'Archivo actualizado con éxito.' });
            } else {
                setSwalProps({ show: true, title: 'Actualizar archivo', text: 'No se pudo actualizar el archivo.' });
            }
            handleClose();
            await CargarListaAtenciones(idCabezaFamilia);
            // Lógica para actualizar archivo
        } catch (error) {
            setSwalProps({ show: true, title: 'Actualizar archivo', text: 'Ocurrió un error al actualizar el archivo.' });
        }
    }
    const handleClose = () => setShowActualizarArchivo(false);
    const handleShow = () => setShowActualizarArchivo(true);
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Listar atenciones jur&iacute;dicas" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Listar atenciones" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                    <div className="row">
                        <div className="col-md-12">
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Atenciones jur&iacute;dicas registradas</h3>
                                </CardHeader>
                                <CardBody>
                                    {/* Tabla de atenciones */}
                                    {atenciones && atenciones.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-striped table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Archivo</th>
                                                        <th>Estado</th>
                                                        <th>ID atención</th>
                                                        <th>Fecha</th>
                                                        <th>Tipo ayuda</th>
                                                        <th>Integrante</th>
                                                        <th>Entidad</th>
                                                        <th>Observaciones</th>
                                                        <th>Sede</th>
                                                        <th>Registró</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {atenciones.map((a, idx) => {
                                                        const id = a.id;
                                                        const rowKey = `${id}-${idx}`;
                                                        const expanded = !!expandedMap[rowKey];
                                                        return (
                                                            <Fragment key={rowKey}>
                                                                <tr style={{ cursor: 'pointer' }} onClick={() => setExpandedMap(s => ({ ...s, [rowKey]: !s[rowKey] }))}>
                                                                    <td>
                                                                        {a.archivoatencion ? (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link p-0"
                                                                                onClick={(e) => { e.stopPropagation(); DescargarArchivo(a.archivoatencion); }}
                                                                                aria-label={`Descargar ${a.archivoatencion}`}
                                                                            >
                                                                                {a.archivoatencion}
                                                                            </button>
                                                                        ) : (
                                                                            'Sin archivo'
                                                                        )}
                                                                    </td>
                                                                    <td>{a.atencioncerrada ? 'Cerrada' : 'Abierta'}</td>
                                                                    <td>{id}</td>
                                                                    <td>{formatFecha(a.fecha)}</td>
                                                                    <td>{a.tipoayuda}</td>
                                                                    <td>{a.integrante}</td>
                                                                    <td>{a.entidad}</td>
                                                                    <td>{a.observaciones}</td>
                                                                    <td>{a.sede}</td>
                                                                    <td>{a.usrnombre}</td>
                                                                    <td>
                                                                        {a.archivoatencion ? (
                                                                            <Button 
                                                                                variant="primary" 
                                                                                style={{ color: "#000", fontWeight: "bold" }}
                                                                                onClick={() => ActualizarArchivo(id)}
                                                                            >
                                                                                Actualizar archivo
                                                                            </Button>
                                                                        ) : (
                                                                            'Sin archivo'
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                {expanded && (
                                                                    <tr className="table-active">
                                                                        <td colSpan={9}>{a.observacionjuridica || <em>No hay observación juridica</em>}</td>
                                                                    </tr>
                                                                )}
                                                            </Fragment>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <p className="mb-0">No hay atenciones registradas.</p>
                                    )}
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                    <Modal show={showActualizarArchivo} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Actualizar Archivo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <label htmlFor="archivoJuridico" className="form-label">
                                Seleccionar archivo
                            </label>
                            <input
                                id="archivoJuridico"
                                type="file"
                                className="form-control"
                                onChange={(e) => setArchivoActualizar(e.target.files[0])}
                                accept=".pdf"
                                required
                                title="Seleccione un archivo PDF"
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cerrar
                            </Button>
                            <Button variant="primary" onClick={() => {
                                handleActualizarArchivo();
                            }}>
                                Actualizar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}